import { render, staticRenderFns } from "./reactivos-columnas.vue?vue&type=template&id=33ab0c91&"
import script from "./reactivos-columnas.vue?vue&type=script&lang=js&"
export * from "./reactivos-columnas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports